import React, {Component} from 'react'

import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/heroSection8';
import TrustedCompany from '../components/TrustedCompany/TrustedCompany7';
import PromoSection from '../components/PromoSection/Promo8';
import AboutSection from '../components/AboutUs/AboutUs8';
import ServiceSection from '../components/Service/Service2';
import Pricing from '../components/Pricing';
import Testimonial from '../components/Testimonial';
import Contact from '../components/Contact';
import ActionToCall from '../components/ActionToCall';
import Footer from '../components/footer/footer';


class Theme8 extends Component{
    render(){
        return(
            <div>
                <Header />
                <div className="main">
                    <HeroSection />
                    <TrustedCompany />
                    <PromoSection />
                    <AboutSection />
                    <ServiceSection />
                    <Pricing />
                    <Testimonial />
                    <Contact />
                    <ActionToCall />
                </div>
                <Footer />
            </div>
        )
    }
}

export default Theme8